export default "__VITE_ASSET__f83eac21__"